<template>
  <div id="Login">
    <div class="p-4">
      <div class="m-4" v-show="false">
        <span class="login-title">{{ title }}</span>
      </div>
      <div class="m-4">
        <van-field v-model="userName" clearable placeholder="输入登录账号">
          <template slot="left-icon">
            <i class="fa fa-fw fa-2x fa-user color-gray"></i>
          </template>
        </van-field>
        <van-field
          v-model="userPassword"
          :type="showPassword ? 'text' : 'password'"
          placeholder="输入登录密码"
        >
          <template slot="left-icon">
            <i class="fa fa-fw fa-2x fa-lock color-gray"></i>
          </template>
          <template slot="right-icon">
            <i
              v-if="showPassword"
              class="fa fa-fw fa-eye color-gray"
              @click="showPassword = false"
            ></i>
            <i
              v-else
              class="fa fa-fw fa-eye-slash color-gray"
              @click="showPassword = true"
            ></i>
          </template>
        </van-field>
      </div>
      <div class="m-4">
        <van-button type="info" round class="mt-2 w-100" @click="loginBtn"
          >登录</van-button
        >
      </div>
    </div>
    <div class="color-gray" style="margin-top: 5rem">
      <van-divider :style="{ borderColor: '#ffffff' }"
        >{{ copyright }}
    </br>
        {{copyright1}}
      </van-divider>
      <p v-if="false">
        <small>{{ title }} v{{ parseFloat(Ver(), 2) }}</small>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data () {
    return {
      title: "登录考务系统",
      msg: "考务环节上报终端",
      copyright: "Copyright © 2025 山东省人事考试中心",
      copyright1: "鲁ICP备2021017574号-3X",
      userName: "",
      userPassword: "",
      showPassword: false,
      clientInfo: {}
    };
  },
  methods: {
    loginBtn: function () {
      if (this.userName == "") {
        this.$toast("登陆账号不可以为空");
        return 0;
      }
      if (this.userPassword == "") {
        this.$toast("登陆密码不可以为空");
        return 0;
      }
      var num = '';
      if (this.userPassword.length < 10)
        num = "0" + this.userPassword.length
      else
        num = this.userPassword.length
      var json = {
        UserName: this.userName,
        Password: this.encrypt(num + this.userPassword),
        //eslint-disable-next-line
        ClientID: this.clientInfo.clientid
      };
      this.apiLoginPost(json, this, res => {
        // eslint-disable-next-line no-console
        if (res.code == 20000) {
          this.setOrganID(res.data.OrganID);
          this.setAuth(res.data);
          if ('OrganID' in res.data) {
            if (res.isSet == true) {
              this.$router.push({ name: "UpdateUserInfo" }).catch(err => err);
            } else {
              this.$router.push({ name: "ExamManage" }).catch(err => err);
            }
          } else {
            this.$toast(res.message);
            this.$router.push({ name: "ChangePwd" }).catch(err => err);
          }
        } else {
          this.$toast(res.message);
        }
      });
    }
  },
  created () {
    //在实例创建完成后被立即调用
  },
  mounted () {
    //el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子
    if (window.plus) {
      //eslint-disable-next-line
      this.clientInfo = plus.push.getClientInfo();
    }
  }
};
</script>

<style scoped>
.login-title {
  font-size: 22px;
}
.mui-content {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.6rem 0 0 0;
  /* background: url("../assets/back-blue.png") no-repeat; */
  background-size: 100% 100%;
}
</style>
